//we can send props to this component : ttl (it can be NA means blank), linkValue, setLinkValue, multiple, mediaType (images, videos, files, allfiles)

// in parent component
// --------------------
//
// 1// add state for linkValue
// const [imageLinkValue, setImageLinkValue] = useState("");
//
// 2// call MediaPopup component
// <MediaPopup
//   ttl="Image"
//   linkValue={imageLinkValue}
//   setLinkValue={setImageLinkValue}
//   mediaType="image"
// />

// --------- !warning -------
// all fields are compulsory.
// Unique name is mandatory as 'ttl'.

// ??????????? Error ????????????
// 1. Cannot read properties of undefined (reading 'backdrop')
// solution: Don't add a space in "ttl" (add an underscore instead).
// example: replace "Video Thumbnail" to "Video_Thumbnail"

import React, { useEffect, useState } from "react";
import config from "../../config";
import Spinner from "../loadingbar/Spinner";
import { useNavigate } from "react-router-dom";

const MediaPopup = (props) => {
  const [loading, setLoading] = useState(false);
  const token = config.token;
  const navigate = useNavigate();

  const { ttl, linkValue, setLinkValue, mediaType, multiple, setFileValue } =
    props;
  const [selectedRadioId, setSelectedRadioId] = useState(`imagelink${ttl}`);
  const [selectedMedia, setSelectedMedia] = useState(multiple ? [] : "");
  const [mediaList, setMediaList] = useState([]);

  const clearSelectedMedia = () => {
    setSelectedMedia(multiple ? [] : "");
  };
  const handleRadioChange = (event) => {
    setLinkValue("");
    setSelectedRadioId(event.target.id);
  };
  const linkValueChange = (e) => {
    // setLinkValue(e.target.value);
    if (multiple) {
      setLinkValue([e.target.value]);
    } else {
      if (selectedRadioId === `filemedia${ttl}`) {
        console.log(e.target.files[0]);
        setFileValue && setFileValue(e.target.files[0]);
        setLinkValue(e.target.value);
      } else {
        setFileValue && setFileValue("");
        setLinkValue(e.target.value);
      }
    }
  };

  const handleSelectMedia = async (media) => {
    if (!multiple) {
      await setSelectedMedia(media);
      await setLinkValue(media.media_name);
    } else {
      const newSelectedMedia = [...selectedMedia];
      const mediaIndex = newSelectedMedia.findIndex(
        (item) => item.media_id === media.media_id
      );
      if (mediaIndex === -1) {
        newSelectedMedia.push(media);
      } else {
        newSelectedMedia.splice(mediaIndex, 1);
      }
      await setSelectedMedia(newSelectedMedia);
      await setLinkValue(newSelectedMedia.map((item) => item.media_name));
    }
  };

  //----------------------------------------------- get media list -------------------------------------------------------R

  const getMedia = () => {
    setLoading(true);
    fetch(`${config.host_url}media`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setMediaList(data.data);
        } else if (data.status === 401) {
          console.error("Invalid token");
        } else {
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching media:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    // Fetch media items
    getMedia();
  }, [token]);
  // Separate arrays for videos and images
  const videos = mediaList.filter((media) => media.media_type === "video");
  const images = mediaList.filter((media) => media.media_type === "image");
  const files = mediaList.filter(
    (media) => media.media_type !== "video" && media.media_type !== "image"
  );
  return (
    <>
      <div className="col-md-12">
        {ttl !== "NA" && (
          <label className="form-check-label ml-1">{ttl ? ttl : "Media"}</label>
        )}
        <div className="col mt-2">
          <div className="form-check form-check-inline ml-1">
            <input
              defaultChecked
              name={`form-check-group-image${ttl}`}
              className="form-check-input"
              type="radio"
              value=""
              id={`imagelink${ttl}`}
              onChange={handleRadioChange}
            />
            <label className="form-check-label" htmlFor={`imagelink${ttl}`}>
              Enter Link
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              name={`form-check-group-image${ttl}`}
              className="form-check-input"
              type="radio"
              value=""
              id={`imagemedia${ttl}`}
              onChange={handleRadioChange}
            />
            <label className="form-check-label" htmlFor={`imagemedia${ttl}`}>
              Import Form Media
            </label>
          </div>
          {setFileValue && (
            <div className="form-check form-check-inline">
              <input
                name={`form-check-group-image${ttl}`}
                className="form-check-input"
                type="radio"
                value=""
                id={`filemedia${ttl}`}
                onChange={handleRadioChange}
              />
              <label className="form-check-label" htmlFor={`filemedia${ttl}`}>
                Upload a File
              </label>
            </div>
          )}
          <div className="row">
            <div
              className={`col-md-${selectedRadioId === `imagelink${ttl}`
                  ? 12
                  : selectedRadioId === `imagemedia${ttl}`
                    ? 10
                    : 12
                }`}
            >
              <div className="form-floating form-floating-outline mb-4">
                <input
                  type={`${selectedRadioId === `filemedia${ttl}` ? "file" : "text"
                    }`}
                  className="form-control"
                  id="mediaPopupInput"
                  placeholder="Enter Link"
                  disabled={selectedRadioId === `imagemedia${ttl}`}
                  value={linkValue}
                  onChange={linkValueChange}
                  {...(selectedRadioId === `filemedia${ttl}` && {
                    accept: "image/*",
                  })}
                />
                <label htmlFor="mediaPopupInput">
                  {selectedRadioId === `imagelink${ttl}`
                    ? "Enter Link"
                    : "Media Link"}
                </label>
              </div>
            </div>
            {selectedRadioId === `imagemedia${ttl}` && (
              <div className="col-md-2 mb-4">
                <button
                  id="imagemedia"
                  type="button"
                  className="btn btn-secondary h-[45px]"
                  data-bs-toggle="modal"
                  data-bs-target={`#addNewModal${ttl}`}
                >
                  <span className="tf-icons mdi mdi-upload"> Import</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* --------------------------------------------- popups --------------------------------------------- */}
      <div
        className="modal fade "
        id={`addNewModal${ttl}`}
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-simple modal-add-new-cc">
          <div className="modal-content ">
            <div className="modal-body p-md-0 mb-2" style={{ height: "450px", overflowY: "scroll", overflowX: "hidden" }}>
              <div className="flex">
                <h5 className="p-0 m-0 pb-3">Select {ttl}</h5>
                <button
                  type="button"
                  className=" ml-3 pb-3 "
                  onClick={() => {
                    getMedia();
                  }}
                >
                  <span className="mdi mdi-refresh"></span>
                </button>
                <a
                  type="button"
                  className=" ml-3 pb-3 "
                  target="_blank"
                  href="/addmedia"
                >
                  <span className="mdi mdi-cloud-upload"></span>
                </a>
              </div>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={clearSelectedMedia}
              ></button>

              {loading ? (
                <Spinner />
              ) : (
                <>
                  <div className="row">
                    {
                      // -------- images --------
                      mediaType === "images" ? (
                        images.map((media) => (
                          <div
                            className="col-md-3 mb-3"
                            key={`image_${ttl}${media.media_id}`}
                          >
                            <div className="form-check custom-option custom-option-image custom-option-image-check border-0 ">
                              <input
                                className="form-check-input invisible"
                                id={`image_${ttl}${media.media_id}`}
                                type={multiple ? "checkbox" : "radio"}
                                value={`image_${ttl}${media.media_id}`}
                                checked={
                                  selectedMedia &&
                                  selectedMedia.media_id ===
                                  `image_${ttl}${media.media_id}`
                                }
                                onChange={() => {
                                  return handleSelectMedia(media);
                                }}
                              />
                              <label
                                className="form-check-label custom-option-content"
                                htmlFor={`image_${ttl}${media.media_id}`}
                              >
                                <div className={`custom-option-body h-24 ${selectedMedia ? "opacity-0" : ""}`}>
                                  <img
                                    src={media.media_name}
                                    alt={`image_${ttl}${media.media_id}`}
                                  />
                                </div>
                              </label>
                            </div>
                          </div>
                        ))
                      ) : //  -------- videos --------
                        mediaType === "videos" ? (
                          videos.map((media) => (
                            <div
                              className="col-md-3 mb-3"
                              key={`video_${ttl}${media.media_id}`}
                            >
                              <div className="form-check custom-option custom-option-image custom-option-image-check border-0 ">
                                <input
                                  className="form-check-input invisible"
                                  id={`video_${ttl}${media.media_id}`}
                                  type={multiple ? "checkbox" : "radio"}
                                  value={`video_${ttl}${media.media_id}`}
                                  checked={
                                    selectedMedia &&
                                    selectedMedia.media_id ===
                                    `video_${ttl}${media.media_id}`
                                  }
                                  onChange={() => handleSelectMedia(media)}
                                />
                                <label
                                  className="form-check-label custom-option-content"
                                  htmlFor={`video_${ttl}${media.media_id}`}
                                >
                                  <div className="custom-option-body h-24">
                                    <video className="object-cover w-full h-full rounded">
                                      <source
                                        src={media.media_name}
                                        type="video/mp4"
                                      />
                                    </video>
                                  </div>
                                </label>
                              </div>
                            </div>
                          ))
                        ) : //  -------- files --------
                          mediaType === "files" ? (
                            files.map((media) => (
                              <div
                                className="col-md-6 mb-3 "
                                // className={`col-md-6 mb-3 ${
                                //   selectedMedia &&
                                //   selectedMedia.media_id === media.media_id
                                //     ? "border-red-500" // Apply blue border if the media is selected
                                //     : "border-gray" // Apply gray border if the media is not selected
                                // }`}
                                key={media.media_id}
                              >
                                <div className="form-check custom-option   ">
                                  <input
                                    className="form-check-input invisible"
                                    id={media.media_id}
                                    type={multiple ? "checkbox" : "radio"}
                                    value={media.media_id}
                                    checked={
                                      selectedMedia &&
                                      selectedMedia.media_id === media.media_id
                                    }
                                    onChange={() => handleSelectMedia(media)}
                                  />
                                  <label
                                    className="form-check-label custom-option-content"
                                    htmlFor={media.media_id}
                                  >
                                    <div className="flex">
                                      <div className="">
                                        <div
                                          type="text"
                                          className="p-1 border-r-2 border-gray-200"
                                          style={{
                                            height: "100%",
                                            display: "flex",
                                          }}
                                        >
                                          <span className="mdi mdi-file-document my-auto"></span>
                                        </div>
                                      </div>

                                      <div className="form-floating-outline w-full overflow-hidden whitespace-no-wrap ml-1 ">
                                        <div
                                          type="text"
                                          className=" pr-1"
                                          style={{
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <div className="">
                                            <span className="block overflow-hidden line-clamp-1">
                                              {media.media_name &&
                                                media.media_name
                                                  .split("/")
                                                  .pop()
                                                  .split(".")[0]
                                                  .split("-")
                                                  .pop()}
                                            </span>
                                          </div>

                                          <hr className="p-0 m-0" />
                                          <span className="block overflow-hidden line-clamp-1">
                                            {media.media_name &&
                                              media.media_name.split(".")[
                                              media.media_name.split(".").length -
                                              1
                                              ]}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </label>
                                </div>
                              </div>
                            ))
                          ) : // -------- allfiles --------
                            mediaType === "allfiles" ? (
                              mediaList?.map((media) => (
                                <div
                                  className={`col-md-6 mb-3 
            
                       `}
                                  key={`allfiles_${ttl}${media.media_id}`}
                                >
                                  <div className="form-check custom-option custom-option-image custom-option-image-check border-gray">
                                    <input
                                      className="form-check-input invisible"
                                      id={`allfiles_${ttl}${media.media_id}`}
                                      type={multiple ? "checkbox" : "radio"}
                                      value={`allfiles_${ttl}${media.media_id}`}
                                      checked={
                                        selectedMedia &&
                                        selectedMedia.media_id ===
                                        `allfiles_${ttl}${media.media_id}`
                                      }
                                      onChange={() => handleSelectMedia(media)}
                                    />
                                    <label
                                      className="form-check-label custom-option-content"
                                      htmlFor={`allfiles_${ttl}${media.media_id}`}
                                    >
                                      <div className="flex">
                                        <div className="">
                                          <div
                                            type="text"
                                            className="p-1 border-r-2 border-gray-200"
                                            style={{
                                              height: "100%",
                                              display: "flex",
                                            }}
                                          >
                                            <span className="mdi mdi-file-document my-auto"></span>
                                          </div>
                                        </div>

                                        <div className="form-floating-outline w-full overflow-hidden whitespace-no-wrap ml-1 ">
                                          <div
                                            type="text"
                                            className=" pr-1"
                                            style={{
                                              height: "100%",
                                              display: "flex",
                                              flexDirection: "column",
                                            }}
                                          >
                                            <div className="">
                                              <span className="block overflow-hidden line-clamp-1">
                                                {media.media_name &&
                                                  media.media_name
                                                    .split("/")
                                                    .pop()
                                                    .split(".")[0]
                                                    .split("-")
                                                    .pop()}
                                              </span>
                                            </div>

                                            <hr className="p-0 m-0" />
                                            <span className="block overflow-hidden line-clamp-1">
                                              {media.media_name &&
                                                media.media_name.split(".")[
                                                media.media_name.split(".").length -
                                                1
                                                ]}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </label>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <p className="flex justify-center">
                                -------- No files available for selection --------
                              </p>
                            )
                    }
                  </div>

                </>
              )}
            </div>
            <div className="d-flex justify-content-end mt-2">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Select
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MediaPopup;
